import Vue from 'vue';
import AsyncComputed from 'vue-async-computed'
import TextareaAutosize from 'vue-textarea-autosize';
import { MediaQueries } from 'vue-media-queries';
import vSelect from 'vue-select';
import App from './App.vue';
import store from './store';

const mediaQueries = new MediaQueries();

Vue.use(AsyncComputed);
Vue.use(TextareaAutosize);
Vue.use(mediaQueries);

Vue.component('v-select', vSelect);

Vue.config.devtools = true;

const node = document.querySelector('.js-jobs-app');

if (node) {
    new Vue({
        store,
        data: { ...node.dataset },
        render: (h) => h(App),
        mediaQueries
    }).$mount(node);
}
